export const resolveRolSaveSedeId = ({
  dni,
  memberships = [],
  selectedSedeId = "ALL",
  scopeSedeIds = [],
  rolesMap = {},
  preferredSedeId = null,
}) => {
  const memberSedes = Array.from(
    new Set((memberships || []).filter(Boolean).map((value) => String(value).trim()).filter(Boolean))
  );
  const allowedScope = Array.from(new Set((scopeSedeIds || []).map((value) => String(value).trim()).filter(Boolean)));

  if (preferredSedeId && memberSedes.includes(String(preferredSedeId))) {
    return String(preferredSedeId);
  }

  if (selectedSedeId !== "ALL" && memberSedes.includes(String(selectedSedeId))) {
    return String(selectedSedeId);
  }

  if (allowedScope.length > 0) {
    const inScope = memberSedes.find((sedeId) => allowedScope.includes(String(sedeId)));
    if (inScope) return String(inScope);
  }

  if (memberSedes.length > 0) return String(memberSedes[0]);

  const existing = rolesMap[String(dni)]?.sedeId;
  if (existing && String(existing).trim()) return String(existing);

  return "general";
};

export const canSaveRolAssignment = ({
  isEmpresaAdmin = false,
  dni,
  allowedDnis = new Set(),
  scopeSedeIds = [],
  sedeId = "general",
}) => {
  if (isEmpresaAdmin) return true;

  const normalizedDni = String(dni || "").trim();
  if (allowedDnis && allowedDnis.size > 0 && normalizedDni && !allowedDnis.has(normalizedDni)) {
    return false;
  }

  if (!scopeSedeIds || scopeSedeIds.length === 0) return true;

  const normalizedSede = String(sedeId || "general").trim();
  if (!normalizedSede) return true;
  if (normalizedSede === "general") return true;

  return Array.from(scopeSedeIds).map(String).includes(normalizedSede);
};
